import { Routes } from "@angular/router";
import { authGuard } from "@shared/guard/auth.guard";
import { ConfirmationGuard } from "@shared/guard/confirmation.guard";
import { firstTimeLoginGuard } from "@shared/guard/first-time-login.guard";
import { notFoundGuard } from "@shared/guard/not-found.guard";
import { passwordExpiredGuard } from "@shared/guard/password-expired.guard";

import { FirstTimeLoginComponent } from "./views/auth/first-time-login/first-time-login.component";
import { LoginComponent } from "./views/auth/login/login.component";
import { PasswordExpiredComponent } from "./views/auth/password-expired/password-expired.component";
import { ResetPasswordComponent } from "./views/auth/reset-password/reset-password.component";
import { SecretAnswerComponent } from "./views/auth/secret-answer/secret-answer.component";
import { NotFoundComponent } from "./views/not-found/not-found.component";

export const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  {
    path: "login",
    component: LoginComponent,
    // resolve: { user: LoginResolverService },
  },
  {
    path: "secret-answer",
    component: SecretAnswerComponent,
    canDeactivate: [ConfirmationGuard],
  },
  {
    path: "first-time-login",
    component: FirstTimeLoginComponent,
    canActivate: [firstTimeLoginGuard],
  },
  {
    path: "reset-password",
    component: ResetPasswordComponent,
    canDeactivate: [ConfirmationGuard],
  },
  {
    path: "password-expired",
    component: PasswordExpiredComponent,
    canActivate: [passwordExpiredGuard],
    canDeactivate: [ConfirmationGuard],
  },
  // {
  //   path: "summary",
  //   canActivate: [authGuard],
  //   data: { preload: true },
  //   loadChildren: () =>
  //     import("./views/dashboard/dashboard.routes").then(
  //       (m) => m.DASHBOARD_ROUTES,
  //     ),
  // },
  {
    path: "ci",
    loadChildren: () =>
      import("./views/certificate-of-insurance/certificate-of-insurance.routes").then(
        (m) => m.CERTIFICATE_OF_INSURANCE_ROUTES,
      ),
  },
  // {
  //   path: "enquiry",
  //   canActivate: [authGuard],
  //   loadChildren: () =>
  //     import("./views/enquiry/enquiry.routes").then((m) => m.ENQUIRY_ROUTES),
  // },
  {
    path: "home",
    canActivate: [authGuard],
    data: { preload: true },
    loadChildren: () =>
      import("./views/landing-page/landing-page.routes").then(
        (m) => m.LANDING_PAGE_ROUTES,
      ),
  },
  {
    path: "profile",
    canActivate: [authGuard],
    data: { preload: true },
    loadChildren: () =>
      import("./views/profile/profile.routes").then((m) => m.PROFILE_ROUTES),
  },
  {
    path: "e-submission",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./views/e-submission/e-submission.routes").then(
        (m) => m.E_SUBMISSION_ROUTES,
      ),
  },
  {
    path: "sales-management",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./views/sales-management/sales-management.routes").then(
        (m) => m.SALES_MANAGEMENT_ROUTES,
      ),
  },
  {
    path: "administrator",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./views/administrator/administrator.routes").then(
        (m) => m.ADMINISTRATOR_ROUTES,
      ),
  },
  {
    path: "portfolio-management",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./views/portfolio-management/portfolio-management.routes").then(
        (m) => m.PORTFOLIO_MANAGEMENT_ROUTES,
      ),
  },
  {
    path: "reports",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./views/report/report.routes").then((m) => m.REPORT_ROUTES),
  },
  {
    path: "e-library",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./views/e-library/e-library.routes").then(
        (m) => m.E_LIBRARY_ROUTES,
      ),
  },
  {
    path: "customer-management",
    canActivate: [authGuard],
    data: { preload: true },
    loadChildren: () =>
      import("./views/customer-management/customer-management.routes").then(
        (m) => m.CUSTOMER_MANAGEMENT_ROUTES,
      ),
  },
  { path: "404", component: NotFoundComponent, canActivate: [notFoundGuard] },
  { path: "**", redirectTo: "404" },
];
